module.exports = __webpack_public_path__ + "static/media/hackerrank.6b747dbf.png";